import { render, staticRenderFns } from "./salary-increment.vue?vue&type=template&id=43257877&"
import script from "./salary-increment.vue?vue&type=script&lang=js&"
export * from "./salary-increment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports